export const SUBTITLE_VARIANT = {
  DEFAULT: 'default',
  ERROR: 'error',
} as const
